const name = 'amd';

export default {
  name,
  group: `group-${name}`,
  applicationName: name,
  moduleName: 'MWS',
};
